import { useRef, useCallback } from 'react';

/**
 * Simple helper to accumulate a boolean result.
 */
function useBooleanAccumulator() {
    const valueRef = useRef(false);
    const reset = useCallback(() => {
        valueRef.current = false;
    }, []);
    const accumulate = useCallback((b) => {
        valueRef.current || (valueRef.current = b);
    }, []);
    return [valueRef, accumulate, reset];
}

export { useBooleanAccumulator as default };
